import Section from "../common/Section";

export default function ViewCoverageCitiesSkeleton() {
  const skeletonRows = new Array(10).fill(null);

  return (
    <div className="space-y-4 animate-pulse">
      <Section title=" ">
        <h1 className="text-[#212121]/70 font-medium text-lg">
          <div className="h-5 w-64 bg-gray-300 rounded" />
        </h1>
        <div className="col-span-4">
          <div className="border rounded-md overflow-hidden divide-y">
            {/* Table Header */}
            <div className="grid grid-cols-7 gap-4 p-4 bg-gray-100 text-sm font-semibold text-gray-600">
              <div>S/N</div>
              <div>District Name</div>
              <div>District Arabic</div>
              <div>Alias Name (EN)</div>
              <div>Alias Name (AR)</div>
              <div>Created Date</div>
              <div>Actions</div>
            </div>

            {/* Skeleton Rows */}
            {skeletonRows.map((_, i) => (
              <div key={i} className="grid grid-cols-7 gap-4 p-4 items-center">
                <div className="h-4 w-6 bg-gray-300 rounded" />
                <div className="h-4 w-24 bg-gray-300 rounded" />
                <div className="h-4 w-24 bg-gray-300 rounded" />
                <div className="h-4 w-28 bg-gray-300 rounded" />
                <div className="h-4 w-28 bg-gray-300 rounded" />
                <div className="h-4 w-24 bg-gray-300 rounded" />
                <div className="h-8 w-8 bg-gray-300 rounded-full" />
              </div>
            ))}
          </div>
        </div>
      </Section>
    </div>
  );
}
